import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { RecaptchaModule } from 'ng-recaptcha';

@Component({
  selector: 'app-re-captcha',
  standalone: true,
  templateUrl: './re-captcha.component.html',
  styleUrls: ['./re-captcha.component.css'],
  imports: [RecaptchaModule]
})
export class ReCaptchaComponent implements OnInit {
  sitekey: string = environment.capchaSiteKey;
  @Output() captchaEvent = new EventEmitter<string | null>();
  captcha: string | null = null;

  ngOnInit(): void {}

  resolved(captchaResponse: string | null) {
    this.captcha = captchaResponse;
    this.captchaEvent.emit(this.captcha);
    console.log('Resolved captcha with response:', this.captcha);
  }
}
